export default "__VITE_ASSET__Dyp0tsOV__"